var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.0938C14.7091 19.0938 16.5 17.3029 16.5 15.0938C16.5 12.8846 14.7091 11.0938 12.5 11.0938C10.2909 11.0938 8.5 12.8846 8.5 15.0938C8.5 17.3029 10.2909 19.0938 12.5 19.0938Z",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.8438V14.7738C12.75 15.1238 12.57 15.4537 12.26 15.6337L11.5 16.0938",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5008 22.0938H15.5008C19.5208 22.0938 20.2408 20.4838 20.4508 18.5238L21.2008 12.5238C21.4708 10.0838 20.7708 8.09375 16.5008 8.09375H8.5008C4.2308 8.09375 3.5308 10.0838 3.8008 12.5238L4.5508 18.5238C4.7608 20.4838 5.4808 22.0938 9.5008 22.0938Z",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.76327V6.79327C8 4.54327 9.81 2.33327 12.06 2.12327C14.74 1.86327 17 3.97327 17 6.60327V7.98327",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagTimer);
export default __webpack_public_path__ + "static/media/bag-timer.be125d90ae7cc2cd00f7b7adc74e7f55.svg";
export { ForwardRef as ReactComponent };